import React, { Fragment } from 'react'
import {
    Create,
    TextInput,
    SelectInput
} from 'react-admin'
import _ from 'lodash'

import Title from '../Generic/Title'
import { CustomSimpleForm } from '../Generic'

import { rolesChoices } from './data.js'

export const UsuarioCreate = ({ permissions, ...props }) => {
    if (permissions === null) {
        return null
    }
    const role = permissions.role
    const empresas = permissions.empresas

    const empresaChoices = _.reduce(empresas, (result, value, key) => {
        if (value.permissions.includes("admin_users")) {
            result.push({ id: key, name: value.name })
        }
        return result
    }, [])

    return (
        <Fragment>
            <Title title={"Crear Usuario"} />
            <Create {...props}>
                <CustomSimpleForm>
                    { role === "coordinado"
                        ? null
                        : <TextInput source="username" />
                    }
                    <TextInput source="email" />
                    <TextInput source="first_name" />
                    <TextInput source="last_name" />
                    { role === "coordinado"
                        ? (
                            <SelectInput
                                source="empresa"
                                choices={empresaChoices}
                            />
                        )
                        : (
                            <SelectInput
                                source="role"
                                choices={rolesChoices}
                            />
                        )
                    }
                </CustomSimpleForm>
            </Create>
        </Fragment>
    )
};
